const api = 'https://us-central1-bookstore-api-e63c8.cloudfunctions.net/bookstoreApi/apps/dakZx1wGKLj0NbMYW3Dg';

export default api;
